import { z } from 'zod'

export const profileFormSchema = z.object({
  firstName: z.string().min(1, 'settings:profileSettings.firstName').max(100),
  lastName: z.string().min(1, 'settings:profileSettings.lastName').max(100),
  phone: z.string().max(20).optional().or(z.literal('')),
})

export type ProfileFormValues = z.infer<typeof profileFormSchema>
